import React from 'react'
// import PropTypes from 'prop-types'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

import { 
  MainTitle, Subtitle,
  TextContent, HighlightText,
  JsonCodeStyle,
} from '../../../Shared';

import { StyledTableCell, StyledTableRow, useTableStyles } from '../../styles/Table.styled';
import { StyledSeparated } from '../FindNearSegments/FindNearSegments.styled';

function createData(fields, type, description) {
  return { fields, type, description };
}

const listBodyFeedbackRequest = [
  createData('message','string','feedback of user'),
]

const listBodyFeedbackResponse = [
  createData('_id','string','id of feedback'),
  createData('response','string','response of feedback'),
]

const Feedback = props => {
  const classes = useTableStyles();

  const responseSuccessCreate = {
    "code": 200,
    "message": "success",
    "data": {
        "response": "",
        "_id": "5fd0fa8928604b50781a70ec",
        "user": "5fb5e5c874bafc2f3edd1386",
        "message": "Ứng dụng rất tuyệt vời",
        "createdAt": "2020-12-09T16:25:45.227Z",
        "updatedAt": "2020-12-09T16:25:45.227Z",
        "__v": 0
    }
  }

  const responseErrorsCreate = {
    "code": 401,
    "message": "Unauthorized. Token error",
    "errors": [],
    "debugError": {}
  }

  const responseSuccessGetAll = {
    "code": 200,
    "message": "success",
    "data": [
        {
            "response": "",
            "_id": "5fd0fb1428604b50781a70f0",
            "user": "5fb5e5c874bafc2f3edd1386",
            "message": "Ứng dụng rất tuyệt vời",
            "createdAt": "2020-12-09T16:28:04.545Z",
            "updatedAt": "2020-12-09T16:28:04.545Z",
            "__v": 0
        },
        {
            "response": "",
            "_id": "5fcaf87ff7cca25074e35437",
            "user": "5e3b931c31034d0308eb0ea3",
            "message": "text",
            "createdAt": "2020-12-05T03:03:27.933Z",
            "updatedAt": "2020-12-05T03:03:27.933Z",
            "__v": 0
        }
    ]
  }

  const responseSuccessFeedbackResponse = {
    "code": 200,
    "message": "success",
    "data": {
        "response": "Thank you.",
        "_id": "5fd0ff0e28604b50781a70f1",
        "user": "5fb5e5c874bafc2f3edd1386",
        "message": "Ứng dụng rất tuyệt vời",
        "createdAt": "2020-12-09T16:45:02.123Z",
        "updatedAt": "2020-12-09T16:45:45.837Z",
        "__v": 0
    }
  }

  return (
    <div>
      <MainTitle>Feedback</MainTitle>
      <Subtitle id="get-application-info" fontSize={32}>Create feedback for user</Subtitle>
      <Subtitle id="request-feedback">Request</Subtitle>
      <TextContent><b><i>URI: </i></b><HighlightText>api/feedback/create</HighlightText> </TextContent>
      <TextContent><b><i>Method: </i></b>@POST</TextContent>
      <TextContent><b><i>Authorization:</i></b> Bearer Token</TextContent>
      <TextContent><b><i>Body:</i></b></TextContent>
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>Code</StyledTableCell>
              <StyledTableCell align="left">Message</StyledTableCell>
              <StyledTableCell align="left">Description</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {listBodyFeedbackRequest.map((row) => (
              <StyledTableRow key={row.fields}>
                <StyledTableCell>
                  {row.fields}
                </StyledTableCell>
                <StyledTableCell align="left">{
                  row.type
                }</StyledTableCell>
                <StyledTableCell component="th" scope="row" align="left">{
                  row.description
                }</StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Subtitle id="response-feedback-create">Response</Subtitle>
      <Subtitle isSmall id="success-feedback-create">Success</Subtitle>
      <JsonCodeStyle data={responseSuccessCreate} />

      <Subtitle isSmall id="success-direct">Errors</Subtitle>
      <TextContent>Unauthorized</TextContent>
      <JsonCodeStyle data={responseErrorsCreate} />

      <Subtitle id="get-all-application-info" fontSize={32}>Get all feedback of users.</Subtitle>
      <Subtitle id="request-feedback-get-all">Request</Subtitle>
      <TextContent><b><i>URI: </i></b><HighlightText>api/feedback/all</HighlightText> </TextContent>
      <TextContent><b><i>Method: </i></b>@GET</TextContent>

      <Subtitle id="response-feedback-get-all">Response</Subtitle>
      <Subtitle isSmall id="success-feedback-get-all">Success</Subtitle>
      <JsonCodeStyle data={responseSuccessGetAll} />
      
      <Subtitle id="get-application-info" fontSize={32}>Response feedback for user</Subtitle>
      <Subtitle id="request-feedback-response">Request</Subtitle>
      <TextContent><b><i>URI: </i></b><HighlightText>api/feedback/update</HighlightText> </TextContent>
      <TextContent><b><i>Method: </i></b>@POST</TextContent>
      <TextContent><b><i>Body:</i></b></TextContent>
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>Code</StyledTableCell>
              <StyledTableCell align="left">Message</StyledTableCell>
              <StyledTableCell align="left">Description</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {listBodyFeedbackResponse.map((row) => (
              <StyledTableRow key={row.fields}>
                <StyledTableCell>
                  {row.fields}
                </StyledTableCell>
                <StyledTableCell align="left">{
                  row.type
                }</StyledTableCell>
                <StyledTableCell component="th" scope="row" align="left">{
                  row.description
                }</StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Subtitle id="response-feedback-response">Response</Subtitle>
      <Subtitle isSmall id="success-feedback-response">Success</Subtitle>
      <JsonCodeStyle data={responseSuccessFeedbackResponse} />

      <StyledSeparated />
    </div>
  )
}

Feedback.propTypes = {

}

export default Feedback
